export const SCR_UNIT_OPTIONS = [
  { label: 'mg/dL', value: 'mg/dL' },
  { label: 'μmol/L', value: 'μmol/L' },
] as const;

export function normalizeScrUnit(unit?: string | null): string {
  const normalized = String(unit || 'mg/dL').trim();
  const lower = normalized.toLowerCase();

  if (lower === 'mg/dl') return 'mg/dL';
  if (lower === 'umol/l' || lower === 'μmol/l' || lower === 'umol') return 'μmol/L';
  return normalized;
}

export function isScrMicromolUnit(unit?: string | null): boolean {
  return normalizeScrUnit(unit) === 'μmol/L';
}
